// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1863":"2fb4c4ca6e8bea79","2888":"f639210c72d28c52"}[chunkId] + ".css";
};